import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PcsDashboardComponent } from '../shared/components/pcs-dashboard/pcs-dashboard.component';
import { AuthenticationGuard } from 'src/app/authentication.guard';
import { NotificationsListComponent } from '../shared/views/notifications-list/notifications-list.component';
import { HomeComponent } from '../shared/components/home/home.component';
import { ProductMbrListComponent } from '../shared/views/product-mbr-list/product-mbr-list.component';
import { ProductMbrDetailComponent } from '../shared/views/product-mbr-detail/product-mbr-detail.component';
import { LendersListComponent } from '../admin/components/lenders-list/lenders-list.component';
import { ProviderOrganizationListComponent } from '../admin/components/provider-organization-list/provider-organization-list.component';
import { ProvidersListComponent } from '../shared/views/providers-list/providers-list.component';
import { AdministratorListComponent } from '../shared/views/administrator-list/administrator-list.component';
import { LenderOrganizationListComponent } from '../shared/views/lender-organizations/lender-organization-list/lender-organization-list.component';
import { LenderOrganizationRouteResolverComponent } from './lender-organization-route-resolver.component';
const routes: Routes = [
  {
    path: '', component: HomeComponent, children: [
      { path: 'dashboard', component: PcsDashboardComponent },
      { path: 'mbr-list', component: ProductMbrListComponent },
      // { path: 'product-mbr/:productId', component: ProductMbrDetailComponent },
      {path: 'product-mbr/:productId/:lenderId', component: ProductMbrDetailComponent},
      { path: 'notifications-list', component: NotificationsListComponent },
      { 
        path: 'lender-organization-home', 
        component: LenderOrganizationRouteResolverComponent
      },
      { 
        path: 'lender-organization/products', 
        component: LendersListComponent,
        canActivate: [AuthenticationGuard]
      },
      { 
        path: 'lender-organization-list', 
        component: LenderOrganizationListComponent,
        canActivate: [AuthenticationGuard]
      },
      { 
        path: 'lender-organization-list/:id', 
        component: LendersListComponent,
        canActivate: [AuthenticationGuard]
      },
      { 
        path: 'provider-organization-list', 
        component: ProviderOrganizationListComponent,
        canActivate: [AuthenticationGuard]
      },
      { 
        path: 'provider-organization-list/:id', 
        component: ProvidersListComponent,
        canActivate: [AuthenticationGuard]
      },
      { 
        path: 'administrator-list', 
        component: AdministratorListComponent,
        canActivate: [AuthenticationGuard]
      },
      {
        path: 'form-submission',
        loadChildren: () =>
          import(
            '../shared/views/form-submission/form-submission.route'
          ).then((mod) => mod.FORM_SUBMISSION_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'search',
        loadChildren: () =>
          import(
            '../shared/views/general-search/general-search.route'
          ).then((mod) => mod.GENERAL_SEARCH_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'marketing-material',
        loadChildren: () =>
          import(
            '../shared/views/marketing-material/marketing-material.route'
          ).then((mod) => mod.MARKETING_MATERIAL_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'lender-approval',
        loadChildren: () =>
          import(
            '../shared/views/lender-approval/lender-approval.route'
          ).then((mod) => mod.LENDER_APPROVAL_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'mbr-request',
        loadChildren: () =>
          import(
            '../shared/views/mbr-request/mbr.route'
          ).then((mod) => mod.MBR_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'forms-management',
        loadChildren: () =>
          import(
            '../shared/views/forms-management/forms-management.route'
          ).then((mod) => mod.FORMS_MANAGEMENT_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'marketing-material-inventory',
        loadChildren: () =>
          import(
            '../shared/views/marketing-material-inventory/marketing-material-inventory.route'
          ).then((mod) => mod.MARKETING_MATERIAL_INVENTORY_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'corporate-document',
        loadChildren: () =>
          import(
            '../shared/views/corporate-document/corporate-document.route'
          ).then((mod) => mod.CORPORATE_DOCUMENT_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'miscellaneous-document',
        loadChildren: () =>
          import(
            '../shared/views/miscellaneous-document/miscellaneous-document.route'
          ).then((mod) => mod.MISCELLANEOUS_DOCUMENT_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      {
        path: 'provider-approval',
        loadChildren: () =>
          import(
            '../shared/views/provider-approval/provider-approval.route'
          ).then((mod) => mod.PROVIDER_APPROVAL_ROUTES),
        canActivate: [AuthenticationGuard],
      },
      { path: '', redirectTo: '/lender/dashboard', pathMatch: 'full' }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LenderRoutingModule { }
